import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  canonicalPath?: string;
  schemas?: object[];
}

export default function SEOHead({ title, description, canonicalPath, schemas }: SEOHeadProps) {
  const schemasStr = JSON.stringify(schemas);

  useEffect(() => {
    const originalTitle = document.title;

    if (title) {
      document.title = title;
    }

    const metaDesc = document.querySelector('meta[name="description"]');
    const originalDesc = metaDesc?.getAttribute('content') ?? '';
    if (description && metaDesc) {
      metaDesc.setAttribute('content', description);
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    const originalCanonical = canonicalLink?.getAttribute('href') ?? '';
    if (canonicalPath && canonicalLink) {
      const siteUrl = (import.meta.env.VITE_SITE_URL as string) || 'https://example.com';
      canonicalLink.setAttribute('href', `${siteUrl}${canonicalPath}`);
    }

    const injectedScripts: HTMLScriptElement[] = [];
    const parsedSchemas: object[] = JSON.parse(schemasStr || '[]');
    if (parsedSchemas.length > 0) {
      parsedSchemas.forEach((schema, index) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = `seo-schema-${(canonicalPath ?? 'page').replace(/\//g, '-')}-${index}`;
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);
        injectedScripts.push(script);
      });
    }

    return () => {
      if (title) document.title = originalTitle;
      if (description && metaDesc) metaDesc.setAttribute('content', originalDesc);
      if (canonicalPath && canonicalLink) canonicalLink.setAttribute('href', originalCanonical);
      injectedScripts.forEach((s) => s.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, canonicalPath, schemasStr]);

  return null;
}
